import React from 'react';
import { countdownTimerPropTypes } from './CountdownTimerPropTypes';
import { useCountdown } from './hooks/useCountdown';
import { zeroPad } from './utils/zeroPad';
import * as styles from './CountdownTimer.module.scss';
const CountdownTimer = ({
  endDate
}) => {
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown(endDate);
  const totalHours = days > 0 ? days * 24 + hours : hours;
  return /*#__PURE__*/React.createElement("span", {
    className: styles.root
  }, zeroPad(totalHours), ":", zeroPad(minutes), ":", zeroPad(seconds));
};
export default CountdownTimer;